/**
 * Truncates a string to a specified maximum length and appends ellipsis if truncated.
 *
 * @param text - The string to truncate
 * @param max - Maximum number of characters before truncation (default: 10)
 * @returns The original string if shorter than or equal to max, otherwise truncated with '...'
 */
export function truncate(text: string, max = 10) {
  // Return empty string for falsy values (null, undefined, empty string)
  if (!text) return text ?? ''

  // Only truncate and add ellipsis when text exceeds the max length
  if (text.length > max) {
    return `${text.substring(0, max)}...`
  } else {
    return text
  }
}
